import React from 'react';
import './src/utils/font.loader';

import { MuiWrapper } from './src/mui/wrapper';
import { BreezerrWrapper } from './breezerr';
import { ReferralParamsWrapper } from './src/utils/referral.helper';
import { BreakpointWrapper } from './src/utils/is.breakpoint';
import { CoBrandingContextWrapper } from './src/utils/partner.context';
import { GTM } from './src/utils/gtm';
import { WrapRootElementBrowserArgs, WrapPageElementBrowserArgs } from 'gatsby';


export const wrapRootElement = ({ element, pathname }: WrapRootElementBrowserArgs) => {
    return <>
        <ReferralParamsWrapper>
            <BreakpointWrapper>
                <CoBrandingContextWrapper>
                    {element}
                </CoBrandingContextWrapper>
            </BreakpointWrapper>
        </ReferralParamsWrapper>
    </>;
};

export const wrapPageElement = ({ element, props }: WrapPageElementBrowserArgs) => {
    return <>
        <MuiWrapper>
            <BreezerrWrapper>
                {element}
            </BreezerrWrapper>
        </MuiWrapper>

        <GTM />
    </>
};


// export const shouldUpdateScroll = () => {
//     window.scrollTo({
//         top: 0,
//         behavior: 'instant'
//     });
    
//     return false;
// };
